var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},_vm._l((_vm.carHistory),function(carHistoryItem){return _c('v-col',{key:carHistoryItem.id,attrs:{"cols":"12"}},[_c('OrderHistoryItem',{attrs:{"order":carHistoryItem,"car":_vm.carState.cars[carHistoryItem.carId]}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }